import React, { useState, useEffect } from 'react';
import api from '../../../config/axios';
import Swal from 'sweetalert2';
import { FaTimes } from 'react-icons/fa';
import Paginacao from '../../../components/utils/paginacao';

const MeuVisagismoHistoricoClienteModal = ({ usuario, onClose }) => {
    const [pagamentos, setPagamentos] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [activeTab, setActiveTab] = useState('pacotes');
    const limit = 10;

    useEffect(() => {
        if (usuario && usuario.usuario_uuid) {
            fetchPagamentos(currentPage);
        }
    }, [usuario, currentPage]);

    const fetchPagamentos = async (page) => {
        try {
            Swal.fire({
                title: "Carregando...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                page: page,
                limit: limit
            };

            const response = await api.get(`/meu-visagismo/usuario/${usuario.usuario_uuid}/historico-creditos`, { params });

            setPagamentos(response.data || {});
            setTotalPages(Math.ceil((response.data?.pacotes?.length || 0) / limit) || 1);

            Swal.close();
        } catch (error) {
            Swal.close();
        }
    };

    const formatarData = (dataString) => {
        const data = new Date(dataString);
        return data.toLocaleDateString('pt-BR') + ' ' + data.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Histórico de Créditos</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <div className="row mb-3 mt-2">
                            <div className="col-md-8 col-12">
                                <h6 className="mb-3"><strong>Usuário:</strong> {usuario?.nome}</h6>
                                <h6 className="mb-3"><strong>E-mail:</strong> {usuario?.email}</h6>
                            </div>
                            <div className="col-md-4 col-12 text-md-end">
                                <h6 className="mb-1 fw-bold">Créditos Disponíveis</h6>
                                <h3 className="fw-bold text-primary">{pagamentos.creditos_disponiveis || 0}</h3>
                            </div>
                        </div>

                        <ul className="nav nav-tabs mb-3">
                            <li className="nav-item">
                                <button 
                                    className={`nav-link ${activeTab === 'pacotes' ? 'active' : ''}`} 
                                    onClick={() => setActiveTab('pacotes')}
                                >
                                    Pacotes Adquiridos
                                </button>
                            </li>
                            <li className="nav-item">
                                <button 
                                    className={`nav-link ${activeTab === 'usos' ? 'active' : ''}`} 
                                    onClick={() => setActiveTab('usos')}
                                >
                                    Histórico de Uso
                                </button>
                            </li>
                        </ul>

                        <div className="tab-content">
                            <div className={`tab-pane fade ${activeTab === 'pacotes' ? 'show active' : ''}`}>
                                <div className="table-responsive max-h-400">
                                    <table className="table table-striped table-hover">
                                        <thead className="table-custom-primary">
                                            <tr className="thead-fixed">
                                                <th>Quantidade</th>
                                                <th className="text-nowrap">Data de Compra</th>
                                                <th className="text-nowrap">Data de Expiração</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pagamentos.pacotes && pagamentos.pacotes.length > 0 ? (
                                                pagamentos.pacotes.map((pacote) => (
                                                    <tr key={pacote.pacote_id}>
                                                        <td>{pacote.quantidade}</td>
                                                        <td className="text-nowrap">{formatarData(pacote.data_compra)}</td>
                                                        <td className="text-nowrap">{formatarData(pacote.data_expiracao)}</td>
                                                        <td>
                                                            <span className={`badge ${pacote.status === 'ATIVO' ? 'bg-success' : 'bg-secondary'}`}>
                                                                {pacote.status}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center">Nenhum pacote encontrado</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            
                            <div className={`tab-pane fade ${activeTab === 'usos' ? 'show active' : ''}`}>
                                <div className="table-responsive max-h-400">
                                    <table className="table table-striped table-hover">
                                        <thead className="table-custom-primary">
                                            <tr className="thead-fixed">
                                                <th>Quantidade</th>
                                                <th>Data de Uso</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pagamentos.usos && pagamentos.usos.length > 0 ? (
                                                pagamentos.usos.map((uso) => (
                                                    <tr key={uso.uso_id}>
                                                        <td>{uso.quantidade}</td>
                                                        <td>{formatarData(uso.data_uso)}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center">Nenhum uso registrado</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MeuVisagismoHistoricoClienteModal;
